import React, { useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./Individual.css";

import {
  Container,
  Row,
  Col,
  Form,
  Button,
  Card,
  Alert,
} from "react-bootstrap";

import Footer from "./Footer";
import Navbar from "./Navbar";
import Explore from "./Explore";
import Overview from "./Overview";

const Bikeinsurance = () => {
  const [validated, setValidated] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);
  const [formData, setFormData] = useState({
    fullName: "",
    mobileNumber: "",
    emailId: "",
    dateOfBirth: "",
    pincode: "",
    city: "",
    state: "",
    panDetails: "",
    insurer: "",
    requiredLoanAmount: "",
    vehicleManufacturer: "",
    vehicleModel: "",
    vehicleVariant: "",
    uniqueIdentifier: "",
    documentType: "",
    termsAccepted: false,
  });

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const [models, setModels] = useState([]);
  const [variants, setVariants] = useState([]);

  const handleChange = async (e) => {
    const { name, value, type, checked } = e.target;
    const fieldValue = type === "checkbox" ? checked : value;

    let updatedFormData = {
      ...formData,
      [name]: fieldValue,
    };

    if (name === "vehicleManufacturer") {
      const manufacturerData = vehicleData[value] || {
        models: [],
        variants: [],
      };

      updatedFormData = {
        ...updatedFormData,
        vehicleModel: "",
        vehicleVariant: "",
      };

      setModels(manufacturerData.models);
      setVariants(manufacturerData.variants);
    }

    if (name === "pincode" && value.length === 6) {
      try {
        const res = await fetch(
          `https://api.postalpincode.in/pincode/${value}`
        );
        const data = await res.json();

        if (data[0].Status === "Success") {
          const postOffice = data[0].PostOffice[0];
          updatedFormData.city = postOffice.District;
          updatedFormData.state = postOffice.State;
        }
      } catch (error) {
        console.error("Failed to fetch city/state from pincode:", error);
      }
    }
    setFormData(updatedFormData);
  };

  const resetForm = () => {
    setFormData({
      fullName: "",
      mobileNumber: "",
      emailId: "",
      dateOfBirth: "",
      pincode: "",
      city: "",
      state: "",
      panDetails: "",
      insurer: "",
      requiredLoanAmount: "",
      vehicleManufacturer: "",
      vehicleModel: "",
      vehicleVariant: "",
      uniqueIdentifier: "",
      documentType: "",
      termsAccepted: false,
    });
    setValidated(false);
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    const form = event.currentTarget;

    if (form.checkValidity() === false) {
      event.stopPropagation();
    } else {
      console.log("Form data submitted:", formData);
      setShowSuccess(true);
      setTimeout(() => {
        setShowSuccess(false);
        resetForm();
      }, 3000);
    }

    setValidated(true);
  };

  const states = [
    "Andhra Pradesh",
    "Arunachal Pradesh",
    "Assam",
    "Bihar",
    "Chhattisgarh",
    "Goa",
    "Gujarat",
    "Haryana",
    "Himachal Pradesh",
    "Jharkhand",
    "Karnataka",
    "Kerala",
    "Madhya Pradesh",
    "Maharashtra",
    "Manipur",
    "Meghalaya",
    "Mizoram",
    "Nagaland",
    "Odisha",
    "Punjab",
    "Rajasthan",
    "Sikkim",
    "Tamil Nadu",
    "Telangana",
    "Tripura",
    "Uttar Pradesh",
    "Uttarakhand",
    "West Bengal",
    "Delhi",
    "Jammu and Kashmir",
    "Ladakh",
    "Puducherry",
    "Chandigarh",
    "Andaman and Nicobar Islands",
    "Dadra and Nagar Haveli and Daman and Diu",
    "Lakshadweep",
  ];

  const documentTypes = [
    "Aadhar Card",
    "Voter ID",
    "Driving License",
    "Passport",
  ];

  const vehicleData = {
    "Hero MotoCorp": {
      models: ["Splendor Plus", "HF Deluxe", "Glamour", "Xtreme 160R"],
      variants: ["Drum", "Disc", "i3S", "Self Start"],
    },
    "Bajaj Auto": {
      models: ["Pulsar 150", "Pulsar NS200", "Avenger Street", "Dominar 400"],
      variants: ["Standard", "ABS", "Dual Disc", "Fi"],
    },
    "TVS Motor Company": {
      models: ["Apache RTR 160", "Raider 125", "Jupiter", "NTorq 125"],
      variants: ["Disc", "Drum", "Race Edition", "SmartXonnect"],
    },
    "Royal Enfield": {
      models: ["Classic 350", "Hunter 350", "Bullet 350", "Interceptor 650"],
      variants: ["Standard", "Retro", "Chrome", "Custom"],
    },
    "Honda Motorcycle & Scooter India": {
      models: ["Shine", "Unicorn", "Hornet 2.0", "CB350"],
      variants: ["Drum", "Disc", "ABS", "DLX Pro"],
    },
    "Yamaha Motor India": {
      models: ["FZ-S Fi", "R15 V4", "MT-15", "Fascino 125"],
      variants: ["Disc", "ABS", "Bluetooth", "MotoGP Edition"],
    },
    KTM: {
      models: ["Duke 200", "RC 390", "Adventure 250"],
      variants: ["Standard", "BS6", "ABS", "WP Suspension"],
    },
    "Jawa Motorcycles": {
      models: ["Jawa 42", "Perak", "Jawa Standard"],
      variants: ["Single Channel ABS", "Dual Channel ABS"],
    },
    "Harley-Davidson": {
      models: ["Iron 883", "Street Rod", "Forty-Eight", "Pan America 1250"],
      variants: ["Standard", "S", "Special"],
    },
    "BMW Motorrad": {
      models: ["G 310 R", "G 310 GS", "R 1250 GS"],
      variants: ["Standard", "Pro", "Adventure"],
    },
    Ducati: {
      models: ["Monster", "Panigale V2", "Multistrada V4"],
      variants: ["Standard", "S", "SP"],
    },
    Kawasaki: {
      models: ["Ninja 300", "Z650", "Versys 650"],
      variants: ["Standard", "KRT Edition", "Tourer"],
    },
    Aprilia: {
      models: ["RS 660", "Tuono 660", "SR 160"],
      variants: ["Standard", "Race Pack", "Carbon"],
    },
    "MV Agusta": {
      models: ["F3 800", "Brutale 800"],
      variants: ["RC", "Rosso", "Standard"],
    },
  };

  return (
    <>
      <Navbar />

      <div className="row justify-content-center align-items-center text-center">
        <div
          className="position-absolute start-0 w-100 h-100"
          style={{
            background:
              "radial-gradient(circle at top right, #A0FFFFCC 22%, transparent 88px)",
            filter: "blur(88px)", // Corrected value
            zIndex: 0,
            // marginTop:'-12%'
          }}
        ></div>
        <div className="container-fluid pt-lg-5 mt-5">
          <div className="row">
            <div className="col-12">
              <h2 className="fw-bold mb-3 mt-5">Bike Insurance</h2>
            </div>
          </div>
        </div>

        <Card.Header className="text-secondary d-flex justify-content-center align-items-center rounded-4">
          <h5 className="mb-5 mx-auto fs-6">
            To apply for a Bike Insurance, please <br /> fill the details below
          </h5>
        </Card.Header>
      </div>
      <section
        className="insurance-service position-relative overflow-hidden"
        style={{
          background:
            "linear-gradient(180deg, rgba(255, 255, 255, 1) 40%, #F5F2FF 100%, rgba(255, 255, 255, 1) 100%)",
          position: "relative",
          overflow: "hidden",
        }}
      >
        <Container className=" rounded-4">
          <Card className="border-0 rounded-5 ">
            <Card.Body className="bg-light rounded-5">
              {showSuccess && (
                <Alert
                  variant="success"
                  onClose={() => setShowSuccess(false)}
                  dismissible
                >
                  Your application has been submitted successfully!
                </Alert>
              )}

              <Form noValidate validated={validated} onSubmit={handleSubmit}>
                <Card className="mb-5 mt-4 rounded-4">
                  <Card.Body>
                    <h5 className="mb-3 mt-4">Personal details</h5>
                    <Row className="mb-3">
                      <Col md={4}>
                        <Form.Group controlId="fullName">
                          <Form.Label>Full Name</Form.Label>
                          <Form.Control
                            type="text"
                            placeholder="Name (as per PAN Card)"
                            name="fullName"
                            value={formData.fullName}
                            onChange={handleChange}
                            required
                          />
                          <Form.Control.Feedback type="invalid">
                            Please provide your full name.
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                      <Col md={4}>
                        <Form.Group controlId="mobileNumber">
                          <Form.Label>Mobile Number</Form.Label>
                          <Form.Control
                            type="tel"
                            placeholder="OTP will be sent after you click 'Apply'"
                            name="mobileNumber"
                            value={formData.mobileNumber}
                            onChange={handleChange}
                            pattern="[0-9]{10}"
                            required
                          />
                          <Form.Control.Feedback type="invalid">
                            Please provide a valid 10-digit mobile number.
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                      <Col md={4}>
                        <Form.Group controlId="emailId">
                          <Form.Label>Email ID</Form.Label>
                          <Form.Control
                            type="email"
                            placeholder="Enter your email ID"
                            name="emailId"
                            value={formData.emailId}
                            onChange={handleChange}
                            required
                          />
                          <Form.Control.Feedback type="invalid">
                            Please provide a valid email.
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <Col md={4}>
                        <Form.Group controlId="dateOfBirth">
                          <Form.Label>Date of Birth</Form.Label>
                          <Form.Control
                            type="date"
                            placeholder="(dd/mm/yyyy)"
                            name="dateOfBirth"
                            value={formData.dateOfBirth}
                            onChange={handleChange}
                            required
                          />
                          <Form.Control.Feedback type="invalid">
                            Please provide your date of birth.
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                      <Col md={4}>
                        <Form.Group controlId="panDetails">
                          <Form.Label>PAN details</Form.Label>
                          <Form.Control
                            type="text"
                            placeholder="Enter PAN number"
                            name="panDetails"
                            value={formData.panDetails}
                            onChange={handleChange}
                            pattern="[A-Z]{5}[0-9]{4}[A-Z]{1}"
                            required
                          />
                          <Form.Control.Feedback type="invalid">
                            Please provide a valid PAN number.
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                      <Col md={4}>
                        <Form.Group controlId="pincode">
                          <Form.Label>Pincode</Form.Label>
                          <Form.Control
                            type="text"
                            name="pincode"
                            value={formData.pincode}
                            onChange={handleChange}
                            required
                          />
                          <Form.Control.Feedback type="invalid">
                            Please enter a valid pincode.
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <Col md={4}>
                        <Form.Group controlId="city">
                          <Form.Label>City</Form.Label>
                          <Form.Control
                            type="text"
                            name="city"
                            value={formData.city}
                            readOnly
                          />
                          <Form.Control.Feedback type="invalid">
                            Please select a city.
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                      <Col md={4}>
                        <Form.Group controlId="state">
                          <Form.Label>State</Form.Label>
                          <Form.Select
                            name="state"
                            value={formData.state}
                            onChange={handleChange}
                            required
                          >
                            <option value="">Select</option>
                            {states.map((state, index) => (
                              <option key={index} value={state}>
                                {state}
                              </option>
                            ))}
                          </Form.Select>
                          <Form.Control.Feedback type="invalid">
                            Please select a state.
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                      <Col md={4}>
                        <Form.Group controlId="insurer">
                          <Form.Label>Insurer</Form.Label>
                          <Form.Select
                            name="insurer"
                            value={formData.insurer}
                            onChange={handleChange}
                            required
                          >
                            <option value="">Select</option>
                            <option value="ICICI Lombard General Insurance">
                              ICICI Lombard General Insurance
                            </option>
                            <option value="HDFC ERGO General Insurance">
                              HDFC ERGO General Insurance
                            </option>
                            <option value="Bajaj Allianz General Insurance">
                              Bajaj Allianz General Insurance
                            </option>
                            <option value="Tata AIG General Insurance">
                              Tata AIG General Insurance
                            </option>
                            <option value="Reliance General Insurance">
                              Reliance General Insurance
                            </option>
                            <option value="New India Assurance">
                              New India Assurance
                            </option>
                            <option value="United India Insurance">
                              United India Insurance
                            </option>
                            <option value="Oriental Insurance">
                              Oriental Insurance
                            </option>
                            <option value="SBI General Insurance">
                              SBI General Insurance
                            </option>
                            <option value="Kotak Mahindra General Insurance">
                              Kotak Mahindra General Insurance
                            </option>
                            <option value="Future Generali India Insurance">
                              Future Generali India Insurance
                            </option>
                            <option value="Bharti AXA General Insurance (now merged with ICICI Lombard)">
                              Bharti AXA General Insurance (now merged with
                              ICICI Lombard)
                            </option>
                          </Form.Select>
                          <Form.Control.Feedback type="invalid">
                            Please select a insurer.
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                    </Row>
                  </Card.Body>
                </Card>

                <Card className="mb-4 rounded-4">
                  <Card.Body>
                    <h5 className="mb-3">Bike details</h5>
                    <Row className="mb-3">
                      <Col md={6}>
                        <Form.Group controlId="vehicleManufacturer">
                          <Form.Label>Manufacturer</Form.Label>
                          <Form.Select
                            name="vehicleManufacturer"
                            value={formData.vehicleManufacturer}
                            onChange={handleChange}
                            required
                          >
                            <option value="">Select Manufacturer</option>
                            {Object.keys(vehicleData).map((manufacturer) => (
                              <option key={manufacturer} value={manufacturer}>
                                {manufacturer}
                              </option>
                            ))}
                          </Form.Select>
                        </Form.Group>
                      </Col>

                      <Col md={6}>
                        <Form.Group controlId="vehicleModel">
                          <Form.Label>Model</Form.Label>
                          <Form.Select
                            name="vehicleModel"
                            value={formData.vehicleModel}
                            onChange={handleChange}
                            required
                            disabled={models.length === 0}
                          >
                            <option value="">Select Model</option>
                            {models.map((model, index) => (
                              <option key={index} value={model}>
                                {model}
                              </option>
                            ))}
                          </Form.Select>
                        </Form.Group>
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <Col md={6}>
                        <Form.Group controlId="vehicleVariant">
                          <Form.Label>Variant</Form.Label>
                          <Form.Select
                            name="vehicleVariant"
                            value={formData.vehicleVariant}
                            onChange={handleChange}
                            required
                            disabled={variants.length === 0}
                          >
                            <option value="">Select Variant</option>
                            {variants.map((variant, index) => (
                              <option key={index} value={variant}>
                                {variant}
                              </option>
                            ))}
                          </Form.Select>
                        </Form.Group>
                      </Col>
                      <Col md={6}>
                        <Form.Group controlId="uniqueIdentifier">
                          <Form.Label>Unique Identifier</Form.Label>
                          <Form.Select
                            name="uniqueIdentifier"
                            value={formData.uniqueIdentifier}
                            onChange={handleChange}
                            required
                          >
                            <option value="">Select</option>
                            <option value="Chassis Number">
                              Chassis Number
                            </option>
                            <option value="Engine Number">Engine Number</option>
                            <option value="Registration Number">
                              Registration Number
                            </option>
                          </Form.Select>
                          <Form.Control.Feedback type="invalid">
                            Please select an identifier.
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <Col md={6}>
                        <Form.Group controlId="dateOfBirth">
                          <Form.Label>Vechile Registration Date</Form.Label>
                          <Form.Control
                            type="date"
                            placeholder="(dd/mm/yyyy)"
                            name="dateOfBirth"
                            value={formData.dateOfBirth}
                            onChange={handleChange}
                            required
                          />
                          <Form.Control.Feedback type="invalid">
                            Please provide your vehicle registration date.
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                      <Col md={6}>
                        <Form.Group controlId="documentType">
                          <Form.Label>
                            Select any one document you'd like to submit
                          </Form.Label>
                          <Form.Select
                            name="documentType"
                            value={formData.documentType}
                            onChange={handleChange}
                            required
                          >
                            <option value="">Select</option>
                            {documentTypes.map((doc, index) => (
                              <option key={index} value={doc}>
                                {doc}
                              </option>
                            ))}
                          </Form.Select>
                          <Form.Control.Feedback type="invalid">
                            Please select a document type.
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                    </Row>
                  </Card.Body>
                </Card>

                <Row className="mb-3">
                  <Col>
                    <Form.Group controlId="termsAccepted">
                      <Form.Check
                        type="checkbox"
                        name="termsAccepted"
                        checked={formData.termsAccepted}
                        onChange={handleChange}
                        label={
                          <span>
                            By submitting the application, I agree and accept
                            the Terms and Conditions as specified{" "}
                            <a href="/" className="text-primary">
                              here
                            </a>
                          </span>
                        }
                        required
                      />
                      <Form.Control.Feedback type="invalid">
                        You must agree to the terms and conditions.
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                </Row>

                <div className="d-flex gap-3">
                  <Button
                    variant="primary"
                    type="submit"
                    className="px-4 py-2 "
                  >
                    Apply
                  </Button>
                  <Button
                    variant="outline-light bg-primary text-white px-4 py-2 "
                    onClick={resetForm}
                  >
                    Clear
                  </Button>
                </div>
              </Form>
            </Card.Body>
          </Card>
        </Container>
      </section>
      <Overview />
      <Explore />
      <Footer />
    </>
  );
};

export default Bikeinsurance;
